import { Location } from '@angular/common';
import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize, tap } from 'rxjs/operators';

import { PROGRESS_STATUSES, SEMINAR_TYPE } from '@agent-ds/shared/constants';
import { DialogConfig } from '@agent-ds/shared/components/dialog/dialog-config';
import { MailSendConfig } from '@agent-ds/shared/components/mail-send/config';
import { StudentDetailConfig } from '@agent-ds/shared/components/mail-send/configs/student-detail-config';
import { StudentSendConfig } from '@agent-ds/shared/components/mail-send/configs/student-send-config';
import { PopupControlComponent } from '@agent-ds/shared/components/popup-control/popup-control.component';
import { DashboardType, Student, CustomerList, ExpectedCompany, ResponseStatus, StudentSituationMemo } from '@agent-ds/shared/interfaces';
import { SalesAmount } from '@agent-ds/shared/interfaces/sale';
import { UserSearchConditionStudent } from '@agent-ds/shared/interfaces/user-search-condition-student';
import {
  AuthService,
  ExportApiService,
  MasterApiService,
  UserApiService,
  CustomerApiService,
  LayoutGlobalManagementHeaderVisibilityService,
  CustomerExpectedCompanyYomiService
} from '@agent-ds/shared/services';
import { DialogService } from '@agent-ds/shared/services/dialog.service';
import { UserSearchConditionApiService } from '@agent-ds/shared/services/api/user-search-condition-api.service';
import { CacheInterceptor } from '@agent-ds/shared/interceptors/cache.interceptor';
import { UserTeamInjectorProvider } from '@agent-ds/shared/services/api/providers/user-team-injector.provider';
import { cleanObject } from '@agent-ds/shared/util/util';
import { openStudentDetail, openStudentDetailMemo, openStudentMailSend } from '@agent-ds/shared/util/student-detail-actions';
import { StudentTabs } from '@agent-ds/student/pages/student-detail-page/tabs/student-tabs';
import { PageScrollTableComponent } from '../../page-scroll-table/page-scroll-table.component';
import {
  CustomerManagementFilterDialogComponent,
  CheaderFilter,
  EMPTY_CHEADER_FILTER,
  IS2ND_MATCH_VALID_VALUE,
  FILTER_NULL_LABEL,
  resolveDatePeriod,
  resolveMonthPeriod,
} from '../components/customer-management-filter-dialog/customer-management-filter-dialog.component';
import { SearchConditionSaveDialogComponent } from '../components/search-condition-save-dialog/search-condition-save-dialog.component';

@Component({
  selector: 'ag-global-cheader',
  templateUrl: './global-cheader.component.html',
  styleUrls: ['./global-cheader.component.scss'],
})
export class GlobalCustomerHeaderComponent implements OnInit {
  @ViewChild(PageScrollTableComponent, { static: false }) table: PageScrollTableComponent;
  @ViewChild('check5', { static: false }) check5Template: TemplateRef<any>;
  @ViewChild('customer', { static: false }) customerTemplate: TemplateRef<any>;
  @ViewChild('school', { static: false }) schoolTemplate: TemplateRef<any>;
  @ViewChild('graduateYear', { static: false }) graduateYearTemplate: TemplateRef<any>;
  @ViewChild('universityLevel', { static: false }) universityLevelTemplate: TemplateRef<any>;
  @ViewChild('sf', { static: false }) sfTemplate: TemplateRef<any>;
  @ViewChild('actions', { static: false }) actionsTemplate: TemplateRef<any>;
  @ViewChild('textfield', { static: false }) textfieldTemplate: TemplateRef<any>;
  @ViewChild('weekPoint', { static: false }) weekPointTemplate: TemplateRef<any>;
  @ViewChild('is2ndMatch', { static: false }) is2ndMatchTemplate: TemplateRef<any>;
  @ViewChild('check5Introduce', { static: false }) check5IntroduceTemplate: TemplateRef<any>;
  @ViewChild('check5Apply', { static: false }) check5ApplyTemplate: TemplateRef<any>;
  @ViewChild('mypageLoggedInAt', { static: false }) mypageLoggedInAtTemplate: TemplateRef<any>;
  @ViewChild('documentSubmissionStatus', { static: false }) documentSubmissionStatusTemplate: TemplateRef<any>;

  @Output() readonly itemChecked = new EventEmitter<{ item?: any; checked: boolean }>();

  enterprises = []
  studentTabs = {
    OVERVIEW: 0,
    DETAIL: 1,
    ACADEMIC: 2,
    PREFERENCES: 3,
    PROGRESS: 4,
    CONTACTS: 5,
    MESSAGE: 6,
    MEMO: 7,
    FILES: 8,
    SEMINARS: 9,
    MATCHES: 10,
  }

  detailConfig = new StudentDetailConfig();
  sendConfig = new StudentSendConfig();

  tabs = StudentTabs;
  initialized = false;
  caNameSortStatus = 'asc';
  activeSortStatus = 'asc';
  progressSortStatus = 'asc';
  dayChangeSortStatus = 'asc';
  sfSortStatus = 'asc';
  graduateYearSortStatus = 'asc';
  interviewSortStatus = 'asc';
  pickUpMemoRegisterSortStatus = 'asc';
  is2ndMatchSortStatus = 'asc';
  check5IntroduceSortStatus = 'asc';
  check5ApplySortStatus = 'asc';
  mypageLoggedInAtSortStatus = 'asc';
  documentSubmissionStatusSortStatus = 'asc';
  expectedContractMonthSortStatus = 'asc';
  seminarAtSortStatus = 'asc';
  seminarStatusSortStatus = 'asc';
  seminarAt2SortStatus = 'asc';
  seminarStatus2SortStatus = 'asc';
  displayedCustomers: Student[] = [];
  appliedFilter: CheaderFilter = { ...EMPTY_CHEADER_FILTER, graduateYears: [], universityLevels: [], sfRanks: [], caUserIds: [] };

  get checkedItems(): Student[] {
    return this.table ? this.table.checkedItems : [];
  }

  get allChecked(): boolean {
    return this.table.allChecked;
  }

  get totalSize(): number {
    return this.table.totalSize;
  }

  init = false;
  isCustomerVisible = false;
  isCustomerVisibleSubscriber = null;
  loadingCustomer = false;

  readonly MGR_DISPLAY_DASHBOARD_TYPES = [DashboardType.CA_Manager];
  userHasManagementRole = false;
  selectedManagementTeamId: number | null = null;
  userNameMap: Record<number, string> = {};
  loginSubscription: any = null;

  get isMgrMode(): boolean {
    return this.selectedManagementTeamId !== null;
  }

  savedConditions: UserSearchConditionStudent[] = [];
  selectedSavedConditionId: number | null = null;

  customers: Student[] = [];
  currentPage: number = 1;
  readonly pageSize: number = 50;
  totalFilteredCount: number = 0;
  customer_total: number = 0;
  expectedCompanies: {} = {};
  expectedCompaniesWithoutExpected: {} = {};
  expectedCompany: {} = {};
  expectedData: {} = {};
  expectedCompany2: {} = {};
  expectedData2: {} = {};
  expectedCompaniesUIList: Record<string, { label: string; shortLabel: string; value: number }[]> = {};
  pickUpMemo: Record<number, StudentSituationMemo> = {};
  dayChanges: Record<number, { activeCountDayChange: number | null; inProgressNumberDayChange: number | null }> = {};

  constructor(
    protected router: Router,
    protected activeRoute: ActivatedRoute,
    protected location: Location,
    protected exportService: ExportApiService,
    private authService: AuthService,
    private customerApiService: CustomerApiService,
    public readonly masterService: MasterApiService,
    public readonly userService: UserApiService,
    public readonly userTeamInjector: UserTeamInjectorProvider,
    public readonly fb: FormBuilder,
    private globalManagementHeaderVisibilityService: LayoutGlobalManagementHeaderVisibilityService,
    private expectedCompanyYomiService: CustomerExpectedCompanyYomiService,
    private dialogService: DialogService,
    private userSearchConditionApiService: UserSearchConditionApiService,
  ) {}

  private condition: {
    contractDate?: { from?: string; to?: string };
    interviewDate?: { from?: string; to?: string };
  } = {};
  model: SalesAmount = { ca: { users: [], total: null }, rapa: { users: [], total: null } };

  ngOnInit() {
    this.isCustomerVisibleSubscriber = this.globalManagementHeaderVisibilityService.customerVisible$.subscribe(value => {
      this.isCustomerVisible = value;
    });
    this.loginSubscription = this.authService.isLogined().subscribe((logined) => {
      if (logined) {
        this.userHasManagementRole = this.MGR_DISPLAY_DASHBOARD_TYPES.includes(
          this.authService.loginUser.dashboardType as DashboardType
        );
      }
    });
  }

  ngOnDestroy() {
    if (this.isCustomerVisibleSubscriber) {
      this.isCustomerVisibleSubscriber.unsubscribe();
    }
    if (this.loginSubscription) {
      this.loginSubscription.unsubscribe();
    }
  }

  buildExpectedCompaniesUIList(companies: any[]): { label: string; shortLabel: string; value: number }[] {
    return [
      { label: '-----', shortLabel: '-----', value: 0 },
      ...companies.map(company => {
        const shortLabel = company.e_name || '';
        let label = shortLabel;
        const status = this.handlerProgressStatusView(company);
        if (status) {
          label += ` | ${status}`;
        }
        if (company.p_seminar_at) {
          label += ` | ${(company.p_seminar_at as string).slice(0, 10).replace(/-/g, '/')}`;
        }
        if (company.j_id) {
          label += ` | ${company.j_id}`;
        }
        return { label, shortLabel, value: company.p_id };
      }),
    ];
  }

  getExpectedCompanyShortLabel(uiList: { shortLabel: string; value: number }[] | undefined, value: number): string {
    if (!uiList) {
      return '-----';
    }
    const found = uiList.find(item => Number(item.value) === Number(value));
    return found ? found.shortLabel : '-----';
  }

  handlerChangeExpectedCompany(studentId: number, newExpectedCompany: number): void {
    const currentProgressId = (() => {
      const currentExpectedCompany = this.expectedCompanies[studentId].find((ec) => ec.p_expected_company_flag === '1');
      if (!currentExpectedCompany) {
        return 0;
      }

      return currentExpectedCompany.p_id;
    })();

    // newExpectedCompany === progressIdと同じ
    this.customerApiService
      .updateExpectedCompanyFlag(studentId, currentProgressId, newExpectedCompany)
      .subscribe((responseStatus: ResponseStatus) => {
        if (responseStatus.status) {
          this.expectedCompaniesWithoutExpected[studentId] = this.expectedCompanies[studentId].filter((ec) => ec.p_id !== Number(newExpectedCompany)).slice(0, 3);
          const expectedData = this.expectedCompanies[studentId].find((ec) => {
            if (ec.p_id === Number(newExpectedCompany)) {
              return true;
            }
            return false;
          });
          this.expectedData[studentId] = expectedData || {};
        };
      });
  }

  handlerChangeExpectedCompany2(studentId: number, newExpectedCompany: number): void {
    const currentProgressId = (() => {
      const list = (this.expectedCompanies as any)[studentId];
      const current = list ? list.find((ec: any) => Number(ec.p_expected_company2_flag) === 1) : null;
      return current ? current.p_id : 0;
    })();

    this.customerApiService
      .updateExpectedCompany2Flag(studentId, currentProgressId, newExpectedCompany)
      .subscribe((responseStatus: ResponseStatus) => {
        if (responseStatus.status) {
          const list = (this.expectedCompanies as any)[studentId];
          const expectedData = list ? list.find((ec: any) => ec.p_id === Number(newExpectedCompany)) : null;
          (this.expectedData2 as any)[studentId] = expectedData || {};
        }
      });
  }

  getSearchQueryParams(userId, progressType, agentType, canceled) {
    const params: any = {
      hasProgress: 1,
      progressType: progressType,
      status: 2,
    };
    if (agentType === 1) {
      params.paraUserId = userId;
    }
    if (agentType === 3) {
      params.caUserId = userId;
    }
    if (this.condition.contractDate) {
      params.contractOrCancelDateFrom = this.condition.contractDate.from;
      params.contractOrCancelDateTo = this.condition.contractDate.to;
    }
    if (this.condition.interviewDate) {
      params.interviewDateFrom = this.condition.interviewDate.from;
      params.interviewDateTo = this.condition.interviewDate.to;
    }
    if (canceled) {
      params.cancelStatus = 3;
    }
    return params;
  }

  toggleGlobalCustomerHeader(): void {
    const willOpen = !this.isCustomerVisible;
    this.globalManagementHeaderVisibilityService.toggleGlobalCustomerHeader();
    if (willOpen) {
      const teams = this.authService.loginUser.managementTeams;
      this.selectedManagementTeamId = this.userHasManagementRole && teams && teams.length > 0 ? teams[0].id : null;
      this.loadCustomers(this.selectedManagementTeamId !== null ? this.selectedManagementTeamId : undefined);
      if (this.userHasManagementRole && teams) {
        teams.forEach(team => {
          if (team.id !== this.selectedManagementTeamId) {
            this.preloadTeamUsers(team.id);
          }
        });
      }
      this.loadSavedConditions();
    }
  }

  private preloadTeamUsers(teamId: number): void {
    this.customerApiService.getTeamCustomerList(teamId, { from: 0, size: 1 })
      .subscribe((customerList: CustomerList) => {
        (customerList.users || []).forEach(u => {
          this.userNameMap[u.id] = u.name;
        });
      });
  }

  updateTableDataWithTeamId(teamId: number | null): void {
    this.selectedManagementTeamId = teamId;
    this.loadCustomers(teamId !== null ? teamId : undefined);
  }

  getCaName(student: Student): string {
    if (!student.studentUser || student.studentUser.length === 0) {
      return '';
    }
    return this.userNameMap[student.studentUser[0].userId] || '';
  }

  handlerCaNameSort(): void {
    if (this.caNameSortStatus === 'asc') {
      this.caNameSortStatus = 'desc';
      this.customers.sort((a, b) => this.getCaName(b).localeCompare(this.getCaName(a), 'ja'));
    } else {
      this.caNameSortStatus = 'asc';
      this.customers.sort((a, b) => this.getCaName(a).localeCompare(this.getCaName(b), 'ja'));
    }
    this.updateDisplayedCustomers(true);
  }

  private buildFilterParams(filter: CheaderFilter): Record<string, any> {
    const params: Record<string, any> = {};

    if (filter.activeCountMin !== null) {
      params['activeCountFrom'] = filter.activeCountMin;
    }

    if (filter.activeCountMax !== null) {
     params['activeCountTo'] = filter.activeCountMax;
    }

    if (filter.progressCountMin !== null) {
      params['progressCountFrom'] = filter.progressCountMin;
    }

    if (filter.progressCountMax !== null) {
      params['progressCountTo'] = filter.progressCountMax;
    }

    if (filter.studentName) {
      params['fullName'] = filter.studentName;
    }

    if (filter.graduateYears.length > 0) {
      params['graduateYear'] = filter.graduateYears;
    }

    if (filter.academicFieldType) {
      params['academicFieldType'] = filter.academicFieldType;
    }

    if (filter.universityLevels.length > 0) {
      params['universityLevel'] = filter.universityLevels.map(level => `${level}グループ`);
    }

    if (filter.sfRanks.length > 0){
      params['rank'] = filter.sfRanks;
    }

    if (filter.interviewDateFrom) {
      params['interviewDateFrom'] = filter.interviewDateFrom;
    }

    if (filter.interviewDateTo) {
      params['interviewDateTo'] = filter.interviewDateTo;
    }

    if (filter.expectedContractMonthFrom) {
      params['expectedContractMonthFrom'] = `${filter.expectedContractMonthFrom}-01`;
    }

    if (filter.expectedContractMonthTo) {
      params['expectedContractMonthTo'] = `${filter.expectedContractMonthTo}-01`;
    }

    if (filter.contactDateFrom) {
      params['contactDateFrom'] = filter.contactDateFrom;
    }

    if (filter.contactDateTo) {
      params['contactDateTo'] = filter.contactDateTo;
    }

    if (filter.is2ndMatchValue === IS2ND_MATCH_VALID_VALUE) {
      params['secondMatch'] = 'ON';
    } else if (filter.is2ndMatchValue === FILTER_NULL_LABEL) {
      params['secondMatchNotOn'] = true;
    }

    if (filter.check5IntroduceFrom) {
      params['check5IntroduceFrom'] = filter.check5IntroduceFrom;
    }

    if (filter.check5IntroduceTo) {
      params['check5IntroduceTo'] = filter.check5IntroduceTo;
    }

    if (filter.check5ApplyFrom) {
      params['check5ApplyFrom'] = filter.check5ApplyFrom;
    }

    if (filter.check5ApplyTo) {
      params['check5ApplyTo'] = filter.check5ApplyTo;
    }

    if (filter.mypageLoggedInAtFrom) {
      params['mypageLoggedinAtFrom'] = filter.mypageLoggedInAtFrom;
    }

    if (filter.mypageLoggedInAtTo) {
      params['mypageLoggedinAtTo'] = filter.mypageLoggedInAtTo;
    }

    if (filter.documentStatus) {
      params['documentSubmissionStatus'] = filter.documentStatus;
    }

    if (filter.caUserIds.length > 0) {
      params['caUserIds'] = filter.caUserIds;
    }

    if (filter.activeDayChangeMin !== null) {
      params['activeCountDiffFrom'] = filter.activeDayChangeMin;
    }

    if (filter.activeDayChangeMax !== null) {
      params['activeCountDiffTo'] = filter.activeDayChangeMax;
    }

    if (filter.progressDayChangeMin !== null) {
      params['progressCountDiffFrom'] = filter.progressDayChangeMin;
    }

    if (filter.progressDayChangeMax !== null) {
      params['progressCountDiffTo'] = filter.progressDayChangeMax;
    }

    if (filter.enterpriseName) {
      params['enterpriseName'] = filter.enterpriseName;
    }

    if (filter.expectedCompanySeminarDateFrom) {
      params['expectedCompanySeminarDateFrom'] = filter.expectedCompanySeminarDateFrom;
    }

    if (filter.expectedCompanySeminarDateTo) {
      params['expectedCompanySeminarDateTo'] = filter.expectedCompanySeminarDateTo;
    }

    return params;
  }

  private loadCustomers(teamId?: number): void {
    this.loadingCustomer = true;
    CacheInterceptor.requestCountChange.emit(1);

    const params = cleanObject({
      from: 0,
      size: 4000,
      sort: 'registrationStatus',
      order: 'desc',
      ...this.buildFilterParams(this.appliedFilter),
    });

    const request$ = teamId
      ? this.customerApiService.getTeamCustomerList(teamId, params)
      : this.customerApiService.getList(params) as any;

    request$.pipe(
      finalize(() => {
        this.loadingCustomer = false;
        CacheInterceptor.requestCountChange.emit(0);
      }),
    ).subscribe((customerList: CustomerList) => {
      this.customers = customerList.students;
      this.currentPage = 1;
      if (teamId) {
        (customerList.users || []).forEach(u => {
          this.userNameMap[u.id] = u.name;
        });
        this.caNameSortStatus = 'asc';
        this.customers.sort((a, b) => this.getCaName(a).localeCompare(this.getCaName(b), 'ja'));
      } else {
        this.customers.sort((a, b) => {
          if (!b.dynamicData.rank || a.dynamicData.rank < b.dynamicData.rank) {
            return -1;
          }
          if (a.dynamicData.rank > b.dynamicData.rank) {
            return 1;
          }
          return 0;
        });
      }
      this.customer_total = customerList.total;
      this.expectedCompanies = customerList.expectedCompanies;
      this.dayChanges = customerList.dayChanges || {};

      const ec: any = this.expectedCompanies;
      const studentIds = Object.keys(ec);
      studentIds.forEach((studentId) => {
        const foundExpectedCompany = ec[studentId].find((expectedCompany: any) => expectedCompany.p_expected_company_flag === '1' || expectedCompany.p_expected_company_flag === 1);
        if (foundExpectedCompany) {
          (this.expectedCompany as any)[studentId] = foundExpectedCompany.p_id;
          (this.expectedData as any)[studentId] = foundExpectedCompany;
          (this.expectedCompaniesWithoutExpected as any)[studentId] = ec[studentId].filter((ecItem: any) => ecItem.p_id !== foundExpectedCompany.p_id).slice(0, 3);
        } else {
          (this.expectedCompany as any)[studentId] = 0;
          (this.expectedData as any)[studentId] = {};
          (this.expectedCompaniesWithoutExpected as any)[studentId] = [];
        }

        // プルダウン表示用UIリストを構築（企業名 | ステータス | 日付 | 求人ID）
        this.expectedCompaniesUIList[studentId] = this.buildExpectedCompaniesUIList(ec[studentId]);

        const foundExpectedCompany2 = ec[studentId].find(
          (expectedCompany: any) => Number(expectedCompany.p_expected_company2_flag) === 1
        );
        if (foundExpectedCompany2) {
          (this.expectedCompany2 as any)[studentId] = foundExpectedCompany2.p_id;
          (this.expectedData2 as any)[studentId] = foundExpectedCompany2;
        } else {
          (this.expectedCompany2 as any)[studentId] = 0;
          (this.expectedData2 as any)[studentId] = {};
        }

        const customer = this.customers.find((cus) => cus.id === Number(studentId));
        this.pickUpMemo[Number(studentId)] = this.expectedCompanyYomiService
          .pickTop1StudentSituationMemoWithSortAndFormat(
            customer ? customer.studentSituationMemo : undefined
          );
      });

      this.updateDisplayedCustomers();
    });
  }

  openChat(lineId): void {
    this.expectedCompanyYomiService.openChat(lineId);
  }

  getYearMonthFromDateString(dateString) {
    return this.expectedCompanyYomiService.getYearMonthFromDateString(dateString);
  }

  handleUpdateExpectedContractMonth($event, student: Student) {
    this.expectedCompanyYomiService
      .handleUpdateExpectedContractMonth($event.target.value, student)
      .subscribe((res) => this.customerApiService.refreshEvent.emit());
  }

  handlerGraduateYearView(year): String {
    if (!isNaN(year)) {
      const newYear = String(year);
      return newYear.slice(2);
    }
    return year.slice(2);
  }

  handlerDateMonthDay(dateData): String {
    const newMonthDay =  dateData.slice(5, 10);

    return newMonthDay.replace("-", '/');
  }

  handlerDateMonthDayPlusjp(dateData) {
    const newMonthDay =  dateData.slice(5, 10);

    return newMonthDay.replace("-", '/');
  }

  // ES は日付を UTC で保存するため、JST 表示に補正する (+9h)
  toJstDateStr(dateVal: any): string {
    if (!dateVal) {
      return '';
    }
    const ms = new Date(dateVal as string).getTime() + 9 * 60 * 60 * 1000;
    return new Date(ms).toISOString().slice(0, 10);
  }

  onItemSelect(selectedItem: any): void {
    openStudentDetail(selectedItem);
  }

  onItemSelectAndMemo(selectedItem: any): void {
    openStudentDetailMemo(selectedItem);
  }

  openMailSend(config: MailSendConfig = this.detailConfig, student): void {
    openStudentMailSend(config, student);
  }

  handleSaveMemo(studentId: number, memo: StudentSituationMemo) {
    this.expectedCompanyYomiService.handleSaveMemo(studentId, memo, this.authService.loginUser)
      .subscribe(() => {
        this.customerApiService.refreshEvent.emit();
      });
  }

  handleSaveMgrMemo(studentId: number, memo: string) {
    this.expectedCompanyYomiService.handleSaveMgrMemo(studentId, memo)
      .subscribe(() => {
        this.customerApiService.refreshEvent.emit();
      });
  }

  handlerCheckExpectedCompanies(studentId) {
    if (!(studentId in this.expectedCompanies)) {
      return null;
    }

    if (this.expectedCompanies[studentId].length === 0) {
      return null;
    }

    return true;
  }

  handlerExpectedCompanyTypeView(type): String {
    if (type === 0) {
      return 'AG';
    }

    if (type === 1) {
      return 'PLUS';
    }

    return '';
  }

  handlerProgressStatusView(expectedCompany: ExpectedCompany): String {
    let word = '';

    if (!expectedCompany.p_status || !(expectedCompany.p_status in PROGRESS_STATUSES)) {
      return word;
    }

    if (expectedCompany.p_seminar_type === SEMINAR_TYPE.SEMI_FINAL_INTERVIEW) {
      word = '最終前';
    } else if (expectedCompany.p_seminar_type === SEMINAR_TYPE.FINAL_INTERVIEW) {
      word = '最終';
    } else if (expectedCompany.p_n) {
      word = `${expectedCompany.p_n}次`;
    }

    word = word + PROGRESS_STATUSES[expectedCompany.p_status].label;

    return word;
  }

  handlerCompanyNameReplace(name: String): String {
    if (name) {
      return name.replace('株式会社', '');
    }

    return '';
  }

  handlerCheck5PickupMemoStatus(studentId: number): boolean {
    const dPick = this.pickUpMemo[studentId];
    if (!dPick || !dPick.registerDate) {
      return false;
    }

    const now = new Date();

    // 7日以内判定
    return this.isBetweenDate(now, new Date(dPick.registerDate), 7);
  }

  isBetweenDate( now: Date, exDay: Date, num: number ){
    // 差分を絶対値で取得
    const days = Math.abs(exDay.getTime() - now.getTime());
    // 日単位に変換
    const betweenDates = days / (24 * 60 * 60 * 1000);
    return betweenDates < num;

  }

  handlerCheck5SecondMatch(is2ndMatch: []): boolean {
    if (is2ndMatch && is2ndMatch.length >= 1) {
      const found = is2ndMatch.find((second) => second === '有効');
      if (found) {
        return true;
      }
    }

    return false;
  }

  handlerCheck5DocumentSubmissionStatus(document: String): boolean {
    if (document && (document === '有' || document === 'OM有' || document === 'キャリアノート')) {
      return true;
    }

    return false;
  }

  handlerDayChangeSort() {
    const getValue = (student: Student): number => {
      const entry = this.dayChanges[student.id];
      if (!entry) {
        return 0;
      }
      const a = entry.activeCountDayChange !== null ? entry.activeCountDayChange : 0;
      const b = entry.inProgressNumberDayChange !== null ? entry.inProgressNumberDayChange : 0;
      return a + b;
    };

    if (this.dayChangeSortStatus === 'asc') {
      this.dayChangeSortStatus = 'desc';
      this.customers.sort((a, b) => getValue(b) - getValue(a));
    } else {
      this.dayChangeSortStatus = 'asc';
      this.customers.sort((a, b) => getValue(a) - getValue(b));
    }
    this.updateDisplayedCustomers(true);
  }

  handlerActiveSort() {
    if (this.activeSortStatus === 'asc') {
      this.activeSortStatus = 'desc';

      this.customers.sort((a, b) => {
        if (!b.activeCount || a.activeCount > b.activeCount) {
          return -1;
        }
        if (a.activeCount < b.activeCount) {
          return 1;
        }
        return 0;
      });
    } else {
      this.activeSortStatus = 'asc';
      this.customers.sort((a, b) => {
        if (!a.activeCount || a.activeCount < b.activeCount) {
          return -1;
        }
        if (a.activeCount > b.activeCount) {
          return 1;
        }
        return 0;
      });
    }
    this.updateDisplayedCustomers(true);
  }

  handlerProgressSort() {
    if (this.progressSortStatus === 'asc') {
      this.progressSortStatus = 'desc';

      this.customers.sort((a, b) => {
        if (!b.progressCount || a.progressCount > b.progressCount) {
          return -1;
        }
        if (a.progressCount < b.progressCount) {
          return 1;
        }
        return 0;
      });
    } else {
      this.progressSortStatus = 'asc';
      this.customers.sort((a, b) => {
        if (!a.progressCount || a.progressCount < b.progressCount) {
          return -1;
        }
        if (a.progressCount > b.progressCount) {
          return 1;
        }
        return 0;
      });
    }
    this.updateDisplayedCustomers(true);
  }

  handlerGraduateYearSort() {
    if (this.graduateYearSortStatus === 'asc') {
      this.graduateYearSortStatus = 'desc';

      this.customers.sort((a, b) => {
        if (!b.dynamicData.academicHistory1.graduateYear || a.dynamicData.academicHistory1.graduateYear > b.dynamicData.academicHistory1.graduateYear) {
          return -1;
        }
        if (a.dynamicData.academicHistory1.graduateYear < b.dynamicData.academicHistory1.graduateYear) {
          return 1;
        }
        return 0;
      });
    } else {
      this.graduateYearSortStatus = 'asc';
      this.customers.sort((a, b) => {
        if (!a.dynamicData.academicHistory1.graduateYear || a.dynamicData.academicHistory1.graduateYear < b.dynamicData.academicHistory1.graduateYear) {
          return -1;
        }
        if (a.dynamicData.academicHistory1.graduateYear > b.dynamicData.academicHistory1.graduateYear) {
          return 1;
        }
        return 0;
      });
    }
    this.updateDisplayedCustomers(true);
  }

  handlerInterviewSort() {
    if (this.interviewSortStatus === 'asc') {
      this.interviewSortStatus = 'desc';

      this.customers.sort((a, b) => {
        if (!b.dynamicData.interviewDate || a.dynamicData.interviewDate > b.dynamicData.interviewDate) {
          return -1;
        }
        if (a.dynamicData.interviewDate < b.dynamicData.interviewDate) {
          return 1;
        }
        return 0;
      });
    } else {
      this.interviewSortStatus = 'asc';
      this.customers.sort((a, b) => {
        if (!a.dynamicData.interviewDate || a.dynamicData.interviewDate < b.dynamicData.interviewDate) {
          return -1;
        }
        if (a.dynamicData.interviewDate > b.dynamicData.interviewDate) {
          return 1;
        }
        return 0;
      });
    }
    this.updateDisplayedCustomers(true);
  }

  handlerSfSort() {
    if (this.sfSortStatus === 'asc') {
      this.sfSortStatus = 'desc';

      this.customers.sort((a, b) => {
        if (!b.dynamicData.rank || a.dynamicData.rank > b.dynamicData.rank) {
          return -1;
        }
        if (a.dynamicData.rank < b.dynamicData.rank) {
          return 1;
        }
        return 0;
      });
    } else {
      this.sfSortStatus = 'asc';
      this.customers.sort((a, b) => {
        if (!a.dynamicData.rank || a.dynamicData.rank < b.dynamicData.rank) {
          return -1;
        }
        if (a.dynamicData.rank > b.dynamicData.rank) {
          return 1;
        }
        return 0;
      });
    }
    this.updateDisplayedCustomers(true);
  }

  handlerPickUpMemoRegisterSort() {
    if (this.pickUpMemoRegisterSortStatus === 'asc') {
      this.pickUpMemoRegisterSortStatus = 'desc';

      this.customers.sort((a, b) => {
        const aPick = this.pickUpMemo[a.id];
        const bPick = this.pickUpMemo[b.id];
        if (!aPick && !bPick) {
          return 0;
        }
        if (aPick === bPick) {
          return 0;
        }
        if (!bPick || !bPick.registerDate || (aPick && aPick.registerDate > bPick.registerDate)) {
          return -1;
        }
        return 1;
      });
    } else {
      this.pickUpMemoRegisterSortStatus = 'asc';
      this.customers.sort((a, b) => {
        const aPick = (this.pickUpMemo as any)[a.id];
        const bPick = (this.pickUpMemo as any)[b.id];

        if (!aPick && !bPick) {
          return 0;
        }
        if (aPick === bPick) {
          return 0;
        }
        if (!aPick || !aPick.registerDate || (bPick && aPick.registerDate < bPick.registerDate)) {
          return -1;
        }
        return 1;
      });
    }
    this.updateDisplayedCustomers(true);
  }

  handlerIs2ndMatchSort() {
    if (this.is2ndMatchSortStatus === 'asc') {
      this.is2ndMatchSortStatus = 'desc';

      this.customers.sort((a, b) => {
        if (!b.dynamicData.is2ndMatch || a.dynamicData.is2ndMatch > b.dynamicData.is2ndMatch) {
          return -1;
        }
        if (a.dynamicData.is2ndMatch < b.dynamicData.is2ndMatch) {
          return 1;
        }
        return 0;
      });
    } else {
      this.is2ndMatchSortStatus = 'asc';
      this.customers.sort((a, b) => {
        if (!a.dynamicData.is2ndMatch || a.dynamicData.is2ndMatch < b.dynamicData.is2ndMatch) {
          return -1;
        }
        if (a.dynamicData.is2ndMatch > b.dynamicData.is2ndMatch) {
          return 1;
        }
        return 0;
      });
    }
    this.updateDisplayedCustomers(true);
  }

  handlerCheck5IntroduceSort() {
    if (this.check5IntroduceSortStatus === 'asc') {
      this.check5IntroduceSortStatus = 'desc';

      this.customers.sort((a, b) => {
        if (!b.dynamicData.check5Introduce || a.dynamicData.check5Introduce > b.dynamicData.check5Introduce) {
          return -1;
        }
        if (a.dynamicData.check5Introduce < b.dynamicData.check5Introduce) {
          return 1;
        }
        return 0;
      });
    } else {
      this.check5IntroduceSortStatus = 'asc';
      this.customers.sort((a, b) => {
        if (!a.dynamicData.check5Introduce || a.dynamicData.check5Introduce < b.dynamicData.check5Introduce) {
          return -1;
        }
        if (a.dynamicData.check5Introduce > b.dynamicData.check5Introduce) {
          return 1;
        }
        return 0;
      });
    }
    this.updateDisplayedCustomers(true);
  }

  handlerCheck5ApplySort() {
    if (this.check5ApplySortStatus === 'asc') {
      this.check5ApplySortStatus = 'desc';

      this.customers.sort((a, b) => {
        if (!b.dynamicData.check5Apply || a.dynamicData.check5Apply > b.dynamicData.check5Apply) {
          return -1;
        }
        if (a.dynamicData.check5Apply < b.dynamicData.check5Apply) {
          return 1;
        }
        return 0;
      });
    } else {
      this.check5ApplySortStatus = 'asc';
      this.customers.sort((a, b) => {
        if (!a.dynamicData.check5Apply || a.dynamicData.check5Apply < b.dynamicData.check5Apply) {
          return -1;
        }
        if (a.dynamicData.check5Apply > b.dynamicData.check5Apply) {
          return 1;
        }
        return 0;
      });
    }
    this.updateDisplayedCustomers(true);
  }

  handlerMypageLoggedInAtSort() {
    if (this.mypageLoggedInAtSortStatus === 'asc') {
      this.mypageLoggedInAtSortStatus = 'desc';

      this.customers.sort((a, b) => {
        if (!b.mypageLoggedInAt || a.mypageLoggedInAt > b.mypageLoggedInAt) {
          return -1;
        }
        if (a.mypageLoggedInAt < b.mypageLoggedInAt) {
          return 1;
        }
        return 0;
      });
    } else {
      this.mypageLoggedInAtSortStatus = 'asc';
      this.customers.sort((a, b) => {
        if (!a.mypageLoggedInAt || a.mypageLoggedInAt < b.mypageLoggedInAt) {
          return -1;
        }
        if (a.mypageLoggedInAt > b.mypageLoggedInAt) {
          return 1;
        }
        return 0;
      });
    }
    this.updateDisplayedCustomers(true);
  }

  handlerDocumentSubmissionStatusSort() {
    if (this.documentSubmissionStatusSortStatus === 'asc') {
      this.documentSubmissionStatusSortStatus = 'desc';

      this.customers.sort((a, b) => {
        if (!b.dynamicData.documentSubmissionStatus || a.dynamicData.documentSubmissionStatus > b.dynamicData.documentSubmissionStatus) {
          return -1;
        }
        if (a.dynamicData.documentSubmissionStatus < b.dynamicData.documentSubmissionStatus) {
          return 1;
        }
        return 0;
      });
    } else {
      this.documentSubmissionStatusSortStatus = 'asc';
      this.customers.sort((a, b) => {
        if (!a.dynamicData.documentSubmissionStatus || a.dynamicData.documentSubmissionStatus < b.dynamicData.documentSubmissionStatus) {
          return -1;
        }
        if (a.dynamicData.documentSubmissionStatus > b.dynamicData.documentSubmissionStatus) {
          return 1;
        }
        return 0;
      });
    }
    this.updateDisplayedCustomers(true);
  }

  handlerExpectedContractMonthSort() {
    if (this.expectedContractMonthSortStatus === 'asc') {
      this.expectedContractMonthSortStatus = 'desc';
      this.customers.sort((a, b) => {
        const aVal = a.dynamicData ? String(a.dynamicData.expectedContractMonth || '') : '';
        const bVal = b.dynamicData ? String(b.dynamicData.expectedContractMonth || '') : '';
        if (!bVal || aVal > bVal) {
          return -1;
        }
        if (aVal < bVal) {
          return 1;
        }
        return 0;
      });
    } else {
      this.expectedContractMonthSortStatus = 'asc';
      this.customers.sort((a, b) => {
        const aVal = a.dynamicData ? String(a.dynamicData.expectedContractMonth || '') : '';
        const bVal = b.dynamicData ? String(b.dynamicData.expectedContractMonth || '') : '';
        if (!aVal || aVal < bVal) {
          return -1;
        }
        if (aVal > bVal) {
          return 1;
        }
        return 0;
      });
    }
    this.updateDisplayedCustomers(true);
  }

  handlerSeminarAtSort() {
    const getSeminarAt = (customer: Student): string => {
      const exp = (this.expectedData as any)[customer.id];
      return exp && exp.p_seminar_at ? String(exp.p_seminar_at).slice(0, 10) : '';
    };
    if (this.seminarAtSortStatus === 'asc') {
      this.seminarAtSortStatus = 'desc';
      this.customers.sort((a, b) => {
        const aVal = getSeminarAt(a);
        const bVal = getSeminarAt(b);
        if (!bVal || aVal > bVal) {
          return -1;
        }
        if (aVal < bVal) {
          return 1;
        }
        return 0;
      });
    } else {
      this.seminarAtSortStatus = 'asc';
      this.customers.sort((a, b) => {
        const aVal = getSeminarAt(a);
        const bVal = getSeminarAt(b);
        if (!aVal || aVal < bVal) {
          return -1;
        }
        if (aVal > bVal) {
          return 1;
        }
        return 0;
      });
    }
    this.updateDisplayedCustomers(true);
  }

  private getSeminarRoundPriority(seminarType: number): number {
    if (seminarType === SEMINAR_TYPE.FINAL_INTERVIEW) {
      return 2;
    }
    if (seminarType === SEMINAR_TYPE.SEMI_FINAL_INTERVIEW) {
      return 1;
    }
    return 0;
  }

  // 昇順: compareSeminarStatus(a, b) / 降順: compareSeminarStatus(b, a) で呼び分ける。
  // データなし(null)は常にソート末尾に置く。
  private compareSeminarStatus(expA: any, expB: any): number {
    const hasA = expA && expA.p_status != null;
    const hasB = expB && expB.p_status != null;
    if (!hasA && !hasB) {
      return 0;
    }
    if (!hasA) {
      return -1;
    }
    if (!hasB) {
      return 1;
    }
    if (expA.p_status !== expB.p_status) {
      return expA.p_status - expB.p_status;
    }
    const rankA = this.getSeminarRoundPriority(expA.p_seminar_type);
    const rankB = this.getSeminarRoundPriority(expB.p_seminar_type);
    if (rankA !== rankB) {
      return rankA - rankB;
    }
    return (expA.p_n || 0) - (expB.p_n || 0);
  }

  handlerSeminarStatusSort() {
    if (this.seminarStatusSortStatus === 'asc') {
      this.seminarStatusSortStatus = 'desc';
      this.customers.sort((a, b) =>
        this.compareSeminarStatus(
          (this.expectedData as any)[b.id],
          (this.expectedData as any)[a.id],
        )
      );
    } else {
      this.seminarStatusSortStatus = 'asc';
      this.customers.sort((a, b) =>
        this.compareSeminarStatus(
          (this.expectedData as any)[a.id],
          (this.expectedData as any)[b.id],
        )
      );
    }
    this.updateDisplayedCustomers(true);
  }

  handlerSeminarAt2Sort() {
    const getSeminarAt2 = (customer: Student): string => {
      const exp = (this.expectedData2 as any)[customer.id];
      return exp && exp.p_seminar_at ? String(exp.p_seminar_at).slice(0, 10) : '';
    };
    if (this.seminarAt2SortStatus === 'asc') {
      this.seminarAt2SortStatus = 'desc';
      this.customers.sort((a, b) => {
        const aVal = getSeminarAt2(a);
        const bVal = getSeminarAt2(b);
        if (!bVal || aVal > bVal) {
          return -1;
        }
        if (aVal < bVal) {
          return 1;
        }
        return 0;
      });
    } else {
      this.seminarAt2SortStatus = 'asc';
      this.customers.sort((a, b) => {
        const aVal = getSeminarAt2(a);
        const bVal = getSeminarAt2(b);
        if (!aVal || aVal < bVal) {
          return -1;
        }
        if (aVal > bVal) {
          return 1;
        }
        return 0;
      });
    }
    this.updateDisplayedCustomers(true);
  }

  handlerSeminarStatus2Sort() {
    if (this.seminarStatus2SortStatus === 'asc') {
      this.seminarStatus2SortStatus = 'desc';
      this.customers.sort((a, b) =>
        this.compareSeminarStatus(
          (this.expectedData2 as any)[b.id],
          (this.expectedData2 as any)[a.id],
        )
      );
    } else {
      this.seminarStatus2SortStatus = 'asc';
      this.customers.sort((a, b) =>
        this.compareSeminarStatus(
          (this.expectedData2 as any)[a.id],
          (this.expectedData2 as any)[b.id],
        )
      );
    }
    this.updateDisplayedCustomers(true);
  }

  get caUserList(): { id: number; name: string }[] {
    return Object.keys(this.userNameMap).map((id) => ({
      id: Number(id),
      name: this.userNameMap[Number(id)],
    }));
  }

  get pageRangeStart(): number {
    if (this.totalFilteredCount === 0) {
      return 0;
    }
    return (this.currentPage - 1) * this.pageSize + 1;
  }

  get pageRangeEnd(): number {
    return Math.min(this.currentPage * this.pageSize, this.totalFilteredCount);
  }

  get totalPages(): number {
    return Math.ceil(this.totalFilteredCount / this.pageSize);
  }

  get pageNumbers(): (number | string)[] {
    const total = this.totalPages;
    if (total <= 7) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }
    const pages: (number | string)[] = [];
    if (this.currentPage <= 4) {
      for (let i = 1; i <= 5; i++) { pages.push(i); }
      pages.push('...');
      pages.push(total);
    } else if (this.currentPage >= total - 3) {
      pages.push(1);
      pages.push('...');
      for (let i = total - 4; i <= total; i++) { pages.push(i); }
    } else {
      pages.push(1);
      pages.push('...');
      pages.push(this.currentPage - 1);
      pages.push(this.currentPage);
      pages.push(this.currentPage + 1);
      pages.push('...');
      pages.push(total);
    }
    return pages;
  }

  goToPage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }
    this.currentPage = page;
    this.updateDisplayedCustomers();
  }

  get appliedFilterLabel(): string {
    const f = this.appliedFilter;
    const parts: string[] = [];

    if (f.activeCountMin != null || f.activeCountMax != null) {
      parts.push(this.rangeLabel('稼働件数', f.activeCountMin, f.activeCountMax));
    }
    if (f.progressCountMin != null || f.progressCountMax != null) {
      parts.push(this.rangeLabel('進捗件数', f.progressCountMin, f.progressCountMax));
    }
    if (f.activeDayChangeMin != null || f.activeDayChangeMax != null) {
      parts.push(this.rangeLabel('稼働件数前日比', f.activeDayChangeMin, f.activeDayChangeMax));
    }
    if (f.progressDayChangeMin != null || f.progressDayChangeMax != null) {
      parts.push(this.rangeLabel('進捗件数前日比', f.progressDayChangeMin, f.progressDayChangeMax));
    }
    if (f.studentName) {
      parts.push(`求職者名: ${f.studentName}`);
    }
    if (f.graduateYears && f.graduateYears.length) {
      parts.push(`卒業年: ${f.graduateYears.join(', ')}`);
    }
    if (f.academicFieldType) {
      parts.push(`文理: ${f.academicFieldType}`);
    }
    if (f.universityLevels && f.universityLevels.length) {
      parts.push(`大学グループ: ${f.universityLevels.join(', ')}`);
    }
    if (f.interviewDateFrom || f.interviewDateTo) {
      parts.push(`カウンセリング日: ${f.interviewDateFrom}〜${f.interviewDateTo}`);
    }
    if (f.sfRanks && f.sfRanks.length) {
      parts.push(`SF: ${f.sfRanks.join(', ')}`);
    }
    if (f.enterpriseName) {
      parts.push(`ご支援想定企業名: ${f.enterpriseName}`);
    }
    if (f.expectedCompanySeminarDateFrom || f.expectedCompanySeminarDateTo) {
      parts.push(`ご支援想定企業名選考日程: ${f.expectedCompanySeminarDateFrom}〜${f.expectedCompanySeminarDateTo}`);
    }
    if (f.expectedContractMonthFrom || f.expectedContractMonthTo) {
      parts.push(`計上月: ${f.expectedContractMonthFrom}〜${f.expectedContractMonthTo}`);
    }
    if (f.contactDateFrom || f.contactDateTo) {
      parts.push(`コンタクト: ${f.contactDateFrom}〜${f.contactDateTo}`);
    }
    if (f.is2ndMatchValue) {
      parts.push(`セカマ: ${f.is2ndMatchValue}`);
    }
    if (f.check5IntroduceFrom || f.check5IntroduceTo) {
      parts.push(`最終求人紹介: ${f.check5IntroduceFrom}〜${f.check5IntroduceTo}`);
    }
    if (f.check5ApplyFrom || f.check5ApplyTo) {
      parts.push(`最終応募: ${f.check5ApplyFrom}〜${f.check5ApplyTo}`);
    }
    if (f.mypageLoggedInAtFrom || f.mypageLoggedInAtTo) {
      parts.push(`ログイン日: ${f.mypageLoggedInAtFrom}〜${f.mypageLoggedInAtTo}`);
    }
    if (f.documentStatus) {
      parts.push(`書類回収状況: ${f.documentStatus}`);
    }
    if (f.caUserIds && f.caUserIds.length) {
      const names = f.caUserIds.map((id) => this.userNameMap[id] || String(id)).join(', ');
      parts.push(`求職者担当: ${names}`);
    }

    return parts.join(' / ');
  }

  private rangeLabel(label: string, min: number | null, max: number | null): string {
    return `${label}: ${min != null ? min : ''}〜${max != null ? max : ''}`;
  }

  openFilterDialog(): void {
    const dialogRef = this.dialogService.open(CustomerManagementFilterDialogComponent, {
      data: {
        currentFilter: {
          ...this.appliedFilter,
          graduateYears: this.appliedFilter.graduateYears.slice(),
          universityLevels: this.appliedFilter.universityLevels.slice(),
          sfRanks: this.appliedFilter.sfRanks.slice(),
          caUserIds: this.appliedFilter.caUserIds.slice(),
        },
        caUserList: this.caUserList,
        isMgrMode: this.isMgrMode,
      },
    } as DialogConfig);

    dialogRef.afterClosed.subscribe((result?: CheaderFilter & { _saveRequested?: boolean }) => {
      if (result !== undefined) {
        if (result._saveRequested) {
          const { _saveRequested, ...filter } = result;
          this.openSaveConditionDialog(filter as CheaderFilter);
        } else {
          this.appliedFilter = result;
          this.selectedSavedConditionId = null;
          this.loadCustomers(this.selectedManagementTeamId !== null ? this.selectedManagementTeamId : undefined);
        }
      }
    });
  }

  private loadSavedConditions(): void {
    this.userSearchConditionApiService.getStudentConditions().subscribe((conditions) => {
      this.savedConditions = conditions;
    });
  }

  private openSaveConditionDialog(filter: CheaderFilter): void {
    const dialogRef = this.dialogService.open(SearchConditionSaveDialogComponent);
    dialogRef.afterClosed.subscribe((result?: { name: string }) => {
      if (result) {
        this.userSearchConditionApiService
          .saveStudentCondition({ name: result.name, searchCondition: filter })
          .subscribe(() => this.loadSavedConditions());
      }
    });
  }

  onSavedConditionToggled(selected: boolean, condition: UserSearchConditionStudent): void {
    if (selected) {
      const filter = condition.searchCondition as CheaderFilter;
      this.appliedFilter = this.resolveDynamicDatePeriods(filter);
      this.selectedSavedConditionId = condition.id;
    } else {
      this.appliedFilter = { ...EMPTY_CHEADER_FILTER, graduateYears: [], universityLevels: [], sfRanks: [], caUserIds: [] };
      this.selectedSavedConditionId = null;
    }
    this.loadCustomers(this.selectedManagementTeamId !== null ? this.selectedManagementTeamId : undefined);
  }

  private resolveDynamicDatePeriods(filter: CheaderFilter): CheaderFilter {
    const resolved: CheaderFilter = {
      ...filter,
      graduateYears: (filter.graduateYears || []).slice(),
      universityLevels: (filter.universityLevels || []).slice(),
      sfRanks: (filter.sfRanks || []).slice(),
      caUserIds: (filter.caUserIds || []).slice(),
    };

    const dateFields: Array<{ period: keyof CheaderFilter; from: keyof CheaderFilter; to: keyof CheaderFilter }> = [
      { period: 'interviewDatePeriod', from: 'interviewDateFrom', to: 'interviewDateTo' },
      { period: 'expectedCompanySeminarDatePeriod', from: 'expectedCompanySeminarDateFrom', to: 'expectedCompanySeminarDateTo' },
      { period: 'contactDatePeriod', from: 'contactDateFrom', to: 'contactDateTo' },
      { period: 'check5IntroducePeriod', from: 'check5IntroduceFrom', to: 'check5IntroduceTo' },
      { period: 'check5ApplyPeriod', from: 'check5ApplyFrom', to: 'check5ApplyTo' },
      { period: 'mypageLoggedInAtPeriod', from: 'mypageLoggedInAtFrom', to: 'mypageLoggedInAtTo' },
    ];

    for (const field of dateFields) {
      const period = filter[field.period] as string | null | undefined;
      if (period) {
        const range = resolveDatePeriod(period as any);
        if (range) {
          (resolved as any)[field.from] = range.from;
          (resolved as any)[field.to] = range.to;
        }
      }
    }

    const monthPeriod = filter.expectedContractMonthPeriod;
    if (monthPeriod) {
      const range = resolveMonthPeriod(monthPeriod as any);
      if (range) {
        resolved.expectedContractMonthFrom = range.from;
        resolved.expectedContractMonthTo = range.to;
      }
    }

    return resolved;
  }

  onSavedConditionRemoved(condition: UserSearchConditionStudent): void {
    PopupControlComponent.instance.open({
      title: '検索条件の削除',
      content: `検索条件「${condition.name}」を削除してもよろしいですか？`,
      confirmText: 'OK',
      cancelText: 'キャンセル',
      confirmCallback: () => {
        return this.userSearchConditionApiService.deleteStudentCondition(condition.id).pipe(
          tap(() => {
            if (this.selectedSavedConditionId === condition.id) {
              this.onSavedConditionToggled(false, condition);
            }
            this.loadSavedConditions();
          }),
        );
      },
    });
  }

  private updateDisplayedCustomers(resetPage = false): void {
    if (resetPage) {
      this.currentPage = 1;
    }
    this.totalFilteredCount = this.customers.length;
    const start = (this.currentPage - 1) * this.pageSize;
    this.displayedCustomers = this.customers.slice(start, start + this.pageSize);
  }
}
